export const host =
  process.env.REACT_APP_LIVE_URL ||
  "https://exciteenterprise-bqg8fhcqa5ccfnhd.westus3-01.azurewebsites.net";

// export const host = "http://localhost:5100";

// export const host = process.env.NODE_ENV === "development" ? process.env.REACT_APP_LOCAL_URL : process.env.REACT_APP_LIVE_URL
